import { ApiResourceMethod } from '@/api/api-requests-factory';
import type { CashierConfig } from '@/models/cashier-settings/cashier-settings.model';

export default class CreateCashierConfig extends ApiResourceMethod<CashierConfig> {
  public perform(country: string) {
    return this.performer.request({ data: { country } });
  }
}
